import React from "react";
import { ChevronDown } from "lucide-react";

/**
 * FAQItem component for individual accordion rows
 */
const FAQItem = ({ question, answer, isOpen, onClick }) => {
  return (
    <div
      className={`group bg-white rounded-[20px] border border-slate-100 transition-all duration-300 overflow-hidden ${
        isOpen ? "shadow-md shadow-slate-200/50" : "hover:border-slate-200"
      }`}
    >
      <button
        onClick={onClick}
        className="w-full flex items-center justify-between p-6 sm:p-7 text-left transition-colors duration-200"
      >
        <span
          className={`text-[17px] sm:text-[18px] font-bold transition-colors duration-200 ${
            isOpen ? "text-slate-900" : "text-slate-800"
          }`}
        >
          {question}
        </span>
        <div
          className={`shrink-0 w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
            isOpen ? "bg-slate-100 rotate-180" : "bg-[#F7F9FC]"
          }`}
        >
          <ChevronDown
            className={`w-5 h-5 transition-colors duration-300 ${
              isOpen ? "text-slate-900" : "text-slate-400"
            }`}
          />
        </div>
      </button>

      <div
        className={`grid transition-all duration-300 ease-in-out ${
          isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden">
          <div className="px-6 pb-6 sm:px-7 sm:pb-8">
            <p className="text-[#5B6B80] text-[15px] sm:text-[16px] leading-relaxed max-w-[90%] font-medium">
              {answer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQItem;
